import LegalLayout from "../components/LegalLayout";
import { TERMS_TEXT } from "../constants/legalText";

export default function Terms() {
  return <LegalLayout title="利用規約" text={TERMS_TEXT} />;
}
